// LogoMais — usa branding dinâmico (puxa do /v1/branding)
// Fallback: SVG inline default (caso branding ainda não carregou)
import { useEffect, useState } from 'react';
import { branding as brandingApi } from '../lib/api.js';

// Cache em módulo pra evitar refetch entre componentes
let _cache = null;
let _loaded = false;
const _listeners = new Set();

async function carregarBranding(force = false) {
  if (_loaded && !force) return _cache;
  try {
    const r = await brandingApi.get();
    _cache = r.data || {};
    _loaded = true;
    _listeners.forEach(fn => fn(_cache));
  } catch {
    _cache = {};
    _loaded = true;
  }
  return _cache;
}

export function useBranding() {
  const [b, setB] = useState(_cache);
  useEffect(() => {
    if (!_loaded) carregarBranding();
    _listeners.add(setB);
    function refresh() { carregarBranding(true); }
    window.addEventListener('branding-updated', refresh);
    return () => {
      _listeners.delete(setB);
      window.removeEventListener('branding-updated', refresh);
    };
  }, []);
  return b || {};
}

export default function LogoMais({ size = 38, mostrarTexto = true }) {
  const b = useBranding();
  const logoUrl  = b?.logo_url;
  const nome     = b?.nome_empresa     || 'Mais Internet';
  const tagline  = b?.tagline          || 'Field Service';
  const corPrim  = b?.cor_primaria     || '#F15D22';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      {logoUrl ? (
        <img src={logoUrl} alt={nome} width={size} height={size} style={{ objectFit: 'contain' }} />
      ) : (
        // Fallback inline (caso branding não carregou)
        <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="50" r="50" fill={corPrim}/>
        </svg>
      )}
      {mostrarTexto && (
        <div style={{
          fontWeight: 800, color: corPrim, fontSize: 18,
          letterSpacing: '-0.4px', lineHeight: 1.05,
        }}>
          {nome.split(' ')[0]?.toLowerCase()}
          <div style={{ color: '#111827', fontWeight: 500, fontSize: 14 }}>
            {nome.split(' ').slice(1).join(' ').toLowerCase() || tagline.toLowerCase()}
          </div>
        </div>
      )}
    </div>
  );
}
